import {validate} from 'email-validator';

export const isValidEmail = (email: string) => {
    return validate(email);
};

export const isValidPlutoEmail = (email: string) => {
    const plutoRegexp = /@pluto\.tv$/;
    
    return plutoRegexp.test(email);
};
